import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ControlContainer } from "../ControlContainer/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { noop } from "../../helpers/utils.js";
import '../../assets/index36.css';const fill = "_fill_lfr9x_11";
const standard = "_standard_lfr9x_14";
const extended = "_extended_lfr9x_28";
const s = {
  "switch": "_switch_lfr9x_1",
  fill,
  standard,
  extended
};
const Switch = withThemeAndSize(
  forwardRef(({ disabled, switchState: radioState, switchSize = "standard", switchClassName, fill: fill2, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(ControlContainer, { ...rest, disabled, ref, fill: fill2, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        role: "switch",
        disabled,
        onClick: noop,
        "aria-checked": Boolean(radioState),
        className: clsx(
          s.switch,
          {
            [s.standard]: switchSize === "standard",
            [s.extended]: switchSize === "extended",
            [s.fill]: fill2
          },
          switchClassName
        )
      }
    ) });
  })
);
export {
  Switch
};
